// test1870
(1870 && 0);
